<modal
    [modalId]="'lookup-form'"
    [modalSize]="'sm'"
    [windowClass]="windowClass"
    (close)="modalCleanup()">
    <div class="modal-inner" modal-inner>
            <ul class="lookup-list lookup-modal-item">
                <li *ngFor="let lookup of data;" class="lookup-item">
                    <span class="lookup-item-name">{{lookup.name}}</span>
                    <button type="button" class="custom-icon-button" (click)="delete(lookup)">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </li>
            </ul>
            <synx-web-pagination class="lookup-paginator lookup-modal-item" [totalRecord]="resultsLength"
                [paging]="paging" [pageSizeOptions]="[5, 10, 25, 100]"
                (pagingChange)="pagingChanged($event)"></synx-web-pagination>
        <div class="add-lookup-container lookup-modal-item">
            <div class="add-lookup custom-field-row">
                <div class="custom-field">
                    <label class="custom-field-label" for="new-lookup-modal-value">New {{lookupName}}</label>
                    <input id="new-lookup-modal-value" class="custom-input" type="text" autocomplete="off" [(ngModel)]="newValue">
                </div>
                <button type="button" class="custom-button custom-button-flat" (click)="addNew()" >
                    Add
                </button>
            </div>
        </div>
    </div>
</modal>
